import React from "react";
import refreshIcon from "../../assets/images/ic-refresh.svg";

function RefreshButton({ onClick }) {
    return (
        <div className="refresh-button-container">
            <button onClick={onClick}>
                <img src={refreshIcon} alt="Refresh" />
            </button>
        </div>
    );
}

export default RefreshButton;
